import { observable, action, decorate } from 'mobx';
import Ajax from '../ajax/ajax';
import { cisoStatuses, eventBusMessages, eventTypesForBus, ownerStatuses } from '../helper/enums';
import EventBus from '../helper/event.bus';

export class RolesStore {

    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    allAvailableRoles = [];

    currentSelectedRole = undefined;

    productionRolesInfo = [];

    createRoleName = "";

    isRoleActionAlreadyTaken = false;

    currentStatusRoles = [];

    approvedRoles = [];

    importantRoles = [];

    rolesForAdditionalApproval = [];

    rolesWithPgsForApproval = [];

    productionRoles = [];

    get getRoles() { return this.currentStatusRoles; }

    get getApprovedRoles() { return this.approvedRoles; }

    setAllAvailableRoles = (val) => this.allAvailableRoles = val;

    setProductionRolesInfo = (val) => this.productionRolesInfo.push(val);

    setRolesWithPgsForApproval = (val) => this.rolesWithPgsForApproval = val;

    setIsRoleActionAlreadyTaken = (val) => this.isRoleActionAlreadyTaken = val;

    setApprovedRoles = (roles) => this.approvedRoles = roles;

    setImportantRoles = (roles) => this.importantRoles = roles;

    setRolesForAdditionalApproval = (roles) => this.rolesForAdditionalApproval = roles;

    setProductionRoles = (roles) => this.productionRoles = roles;

    setCurrentSelectedRole = (role) => this.currentSelectedRole = role;

    setCurrentStatusRoles = (roles) => this.currentStatusRoles = roles;

    setCreateRoleName = (roleName) => this.createRoleName = roleName;

    getProductionRoleByID = (id, callback) => Ajax.getProductionRoleByID(id, this.getProductionRoleByIDSuccess, this.getProductionRoleByIDError);

    getProductionRoleByIDSuccess = (response) => {
        this.setCurrentSelectedRole(response.data);
        this.setProductionRolesInfo(this.currentSelectedRole);
    }
    getProductionRoleByIDError = (response) => console.log(response);

    getPendingRoles = (data) => Ajax.getPendingRoles(data, this.getPendingRolesSuccess, this.getPendingRolesError);

    getPendingRolesSuccess = (response) => {
        this.rootStore.reportingStore.setRenderSpinner(false);
        this.setCurrentStatusRoles(response.data);
    }

    getPendingRolesError = () => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    getRolesWithPgsForApproval = (data) => Ajax.getRolesForPgApproval(data, this.getRolesWithPgsForApprovalSuccess, this.getRolesWithPgsForApprovalError);

    getRolesWithPgsForApprovalSuccess = (response) =>{
        this.rootStore.reportingStore.setRenderSpinner(false);
         this.setRolesWithPgsForApproval(response.data);
    }
    getRolesWithPgsForApprovalError = () => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    getRolesByStatus = (data) => Ajax.getRolesByStatus(data, this.getRolesByStatusSuccess, this.getRolesByStatusError);

    getRolesByStatusSuccess = (response) => {
        this.rootStore.reportingStore.setRenderSpinner(false);
        this.setCurrentStatusRoles(response.data);
    }

    getRolesByStatusError = () => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    getApprovedStatusRoles = (data) => Ajax.getApprovedStatusRoles(data, this.getApprovedStatusRolesSuccess, this.getApprovedStatusRolesError);

    getApprovedStatusRolesSuccess = (response) => {
        this.rootStore.reportingStore.setRenderSpinner(false);
        this.setApprovedRoles(response.data);
    }
    getApprovedStatusRolesError = (error) => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    createRole = (data) => Ajax.createRole(data, this.createRoleSuccess, this.createRoleError);

    createRoleSuccess = () => {
        this.setCreateRoleName("");
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.createRole, eventBusMessages.createRoleSuccess);
    }

    createRoleError = (error) => {
        this.setIsRoleActionAlreadyTaken(false);
        if (error.response !== undefined) {
            EventBus.publish(eventTypesForBus.unexpectedError, error.response.data);
        }
        else EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.createRoleError);
    }
    assignPGsToRole = (data) => Ajax.assignPGsToRole(data, this.assignPGsToRoleSuccess, this.assignPGsToRoleError);

    assignPGsToRoleSuccess = (response) => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.assignPGs, eventBusMessages.assignPermissionGroupsSuccess);
        this.setCurrentStatusRoles(this.currentStatusRoles.filter(role => role.roleID !== response.data));
    }

    assignPGsToRoleError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.assignPermissionGroupsError);
    }
    updateRoleAdditionalApproversCISO = (data) => Ajax.updateRoleAdditionalApproversCISO(data, this.updateRoleAdditionalApproversCISOSuccess, this.updateRoleAdditionalApproversCISOError);

    updateRoleAdditionalApproversCISOSuccess = (response) => {
        this.currentSelectedRole.cisoStatus = response.data.cisoStatus;
        this.setIsRoleActionAlreadyTaken(false);
        if (response.data.ownerStatus !== ownerStatuses.notApproved) {
            this.setCurrentStatusRoles(this.currentStatusRoles.filter(role => role.roleID !== response.data.roleID));
        }
        EventBus.publish(eventTypesForBus.approveRole, eventBusMessages.approveRoleSuccess);
    }

    updateRoleAdditionalApproversCISOError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.approveRoleError);
    }
    updateRoleAdditionalApproversOwner = (data) => Ajax.updateRoleAdditionalApproversOwner(data, this.updateRoleAdditionalApproversOwnerSuccess, this.updateRoleAdditionalApproversOwnerError);

    updateRoleAdditionalApproversOwnerSuccess = (response) => {
        this.currentSelectedRole.ownerStatus = response.data.ownerStatus;
        this.setCurrentStatusRoles(this.currentStatusRoles.filter(role => role.roleID !== response.data.roleID));
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.approveRole, eventBusMessages.approveRoleSuccess);
    }

    updateRoleAdditionalApproversOwnerError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.approveRoleError);
    }

    updateRoleAdditionalApproversPgOwner = (data) => Ajax.updateRoleAdditionalApproversPgOwner(data, this.updateRoleAdditionalApproversPgOwnerSuccess, this.updateRoleAdditionalApproversPgOwnerError);

    updateRoleAdditionalApproversPgOwnerSuccess = (response) => {
        this.setIsRoleActionAlreadyTaken(false);
        let notApprovedRolePermissionGroups = [];
        for (let index = 0; index < this.rolesWithPgsForApproval.length; index++) {
            const rolePermissionGroup = this.rolesWithPgsForApproval[index];
            if (rolePermissionGroup.role.roleId !== response.data.roleId || (rolePermissionGroup.role.roleId === response.data.roleId && rolePermissionGroup.permissionGroup.permissionGroupId !== response.data.permissionGroupId)) {
                notApprovedRolePermissionGroups.push(rolePermissionGroup);
            }
        }
        this.setRolesWithPgsForApproval(notApprovedRolePermissionGroups);
        EventBus.publish(eventTypesForBus.approveRole, eventBusMessages.approveRoleSuccess);
    }

    updateRoleAdditionalApproversPgOwnerError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.approveRoleError);
    }

    assignEmployeesToRole = (data) => Ajax.assignEmployeesToRole(data, this.assignEmployeesToRoleSuccess, this.assignPGsToRoleError);

    assignEmployeesToRoleSuccess = (response) => {
        this.setApprovedRoles(this.approvedRoles.filter(role => role.roleID !== response.data));
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.approveRole, eventBusMessages.assignRoleSuccess);
    }

    assignEmployeesToRoleError = () => {
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
        this.setIsRoleActionAlreadyTaken(false);
    }

    getAssignedImportantRoles = () => Ajax.getAssignedImportantRoles(this.getAssignedImportantRolesSuccess, this.getAssignedImportantRolesError);

    getAssignedImportantRolesSuccess = (response) => this.setImportantRoles(response.data);

    getAssignedImportantRolesError = () => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    getAssignedRolesForAdditionalApproval = (data) => Ajax.getAssignedRolesForAdditionalApproval(data, this.getAssignedRolesForAdditionalApprovalSuccess, this.getAssignedRolesForAdditionalApprovalError);

    getAssignedRolesForAdditionalApprovalSuccess = (response) => {
        this.rootStore.reportingStore.setRenderSpinner(false);
        this.setRolesForAdditionalApproval(response.data);
    }
    getAssignedRolesForAdditionalApprovalError = () => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    cisoApproveRole = (data) => Ajax.cisoApproveRole(data, this.cisoApproveRoleSuccess, this.getAssignedImportantRolesError);

    cisoApproveRoleSuccess = (response) => {
        this.setImportantRoles(this.importantRoles.filter(role => role.rolePersonMapID !== this.currentSelectedRole.rolePersonMapID));
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.cisoApproved, eventBusMessages.cisoApproved);
    }

    cisoApproveRoleError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
    }

    additionalApproveRole = (data) => Ajax.additionalApproveRole(data, this.additionalApproveRoleSuccess, this.assignEmployeesToRoleError);

    additionalApproveRoleSuccess = () => {
        this.setIsRoleActionAlreadyTaken(false);
        this.setRolesForAdditionalApproval(this.rolesForAdditionalApproval.filter(role => role.rolePersonAdditionalApprovalsMap !== this.currentSelectedRole.rolePersonAdditionalApprovalsMap));
        EventBus.publish(eventTypesForBus.approveRole, eventBusMessages.approveRoleSuccess);
    }

    additionalApproveRoleError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
    }

    getProductionRoles = (data) => Ajax.getProductionRoles(data, this.getProductionRolesSuccess, this.getProductionRolesError);

    getProductionRolesSuccess = (response) => {
        this.rootStore.reportingStore.setRenderSpinner(false);
        this.setProductionRoles(response.data);
    }
    getProductionRolesError = () => EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);

    editRole = (data) => Ajax.edit(data, this.editRoleSuccess, this.editRoleError);

    editRoleSuccess = (response) => {
        this.setProductionRoles([...this.productionRoles.filter(r => r.roleID !== this.currentSelectedRole.roleID), response.data]);
        this.setIsRoleActionAlreadyTaken(false);
        this.setCurrentSelectedRole(response.data);
        EventBus.publish(eventTypesForBus.editedRole, eventBusMessages.editedRole);
    }

    editRoleError = () => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
    }

    removeEmployees = (data) => Ajax.removeEmployee(data, this.removeEmployeesSuccess, this.removeEmployeesError);

    removeEmployeesSuccess = (response) => {
        this.setProductionRoles([...this.productionRoles.filter(r => r.roleID !== response.data.roleID), response.data]);
        this.setCurrentSelectedRole(response.data);
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.removedEmployee, eventBusMessages.removedEmployee);
    }

    removeEmployeesError = (error) => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
    }

    getAllRoles = () => Ajax.getAllRoles(this.getAllRolesSuccess, this.getAllRolesError);

    getAllRolesSuccess = (response) => {
        this.rootStore.reportingStore.setRenderSpinner(false);
        this.setAllAvailableRoles(response.data);
    }
    getAllRolesError = (error) => console.log(error);

    updateRoleOwner = (data) => Ajax.updateRoleOwner(data, this.updateRoleOwnerSuccess, this.updateRoleOwnerError);

    updateRoleOwnerSuccess = (response) => {
        let newOwner = this.rootStore.peopleStore.allOwners.find(x => x.id === response.data.ownerId);
        if (newOwner !== undefined) {
            this.currentSelectedRole.ownerName = newOwner.fullName;
        }
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.ownerChange, eventBusMessages.ownerChangeSucess);
    }

    updateRoleOwnerError = (error) => {
        this.setIsRoleActionAlreadyTaken(false);
        EventBus.publish(eventTypesForBus.unexpectedError, eventBusMessages.unexpectedError);
    }
}
decorate(RolesStore, {
    productionRolesInfo: observable,
    setProductionRolesInfo: action,
    currentStatusRoles: observable,
    currentSelectedRole: observable,
    importantRoles: observable,
    rolesForAdditionalApproval: observable,
    productionRoles: observable,
    createRoleName: observable,
    approvedRoles: observable,
    allAvailableRoles: observable,
    isRoleActionAlreadyTaken: observable,
    setCreateRoleName: action,
    setAllAvailableRoles: action,
    setCurrentSelectedRole: action,
    setCurrentSelectedRoles: action,
    setImportantRoles: action,
    setRolesForAdditionalApproval: action,
    setProductionRoles: action,
    setApprovedRoles: action,
    setIsRoleActionAlreadyTaken: action,
    rolesWithPgsForApproval: observable,
    setRolesWithPgsForApproval: action
})